import { Injectable } from '@angular/core';
import { ApiService } from '../..';
@Injectable()
export class ThongKeSanLuongService {

  constructor(
    public api: ApiService

  ) { }
  APIURL_Chung = "api/ExcuteOracle"
  //Lấy báo cáo thống kê
  public baocao_thongkesanluong(danhmucid, tungay, denngay, loaiHienThi, pagenum, numrecs, mataikhoan) {
    var param = {
      "config": '{"namesql":"PKG_BC_SANLUONG.THONGKESANLUONG","connstr":"Amiss42"}',
      "para": '{"v_Danhmucid":"' + danhmucid + '","v_Tungay":"' + tungay + '","v_Denngay":"' + denngay +
        '","v_LoaiHienThi":"' + loaiHienThi + '","v_pagenum":"' + pagenum + '","v_numrecs":"' + numrecs + '","v_mataikhoan":"' + mataikhoan + '"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }

  exportExcel(danhmucid, tungay, denngay, loaiHienThi, tendonvi, tenchucnang, noidungbaocao, thoigian, mataikhoan) {
    let columns = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "makhachhang", "label": "Mã Khách Hàng", "horizontalalignment": "left" },
      { "name": "socongto", "label": "Số Công Tơ", "horizontalalignment": "center" },
      { "name": "hsn", "label": "HSN", "horizontalalignment": "right" },
      { "name": "tongsanluonggiao", "label": "Tổng SL giao (kwh)", "horizontalalignment": "right" },
      { "name": "tongsanluonggiao1", "label": "Tổng SL giao biểu 1 (kwh)", "horizontalalignment": "right" },
      { "name": "tongsanluonggiao2", "label": "Tổng SL giao biểu 2 (kwh)", "horizontalalignment": "right" },
      { "name": "tongsanluonggiao3", "label": "Tổng SL giao biểu 3 (kwh)", "horizontalalignment": "right" },
      { "name": "tongsanluongnhan", "label": "Tổng SL nhận (kwh)", "horizontalalignment": "right" },
      { "name": "tongsanluongnhan1", "label": "Tổng SL nhận biểu 1 (kwh)", "horizontalalignment": "right" },
      { "name": "tongsanluongnhan2", "label": "Tổng SL nhận biểu 2 (kwh)", "horizontalalignment": "right" },
      { "name": "tongsanluongnhan3", "label": "Tổng SL nhận biểu 3 (kwh)", "horizontalalignment": "right" },
    ];
    var param = {
      config: JSON.stringify({ namesql: "PKG_BC_SANLUONG.THONGKESANLUONG" }),
      para: JSON.stringify({
        v_Danhmucid: danhmucid,
        v_Tungay: tungay,
        v_Denngay: denngay,
        v_LoaiHienThi: loaiHienThi,
        v_pagenum: 0,
        v_numrecs: 1000000,
        v_mataikhoan: mataikhoan
      }),
      title: tenchucnang + " " + tendonvi,//+ " " + thoidiemtruyvan,
      header: "Ngày: " + thoigian,
      filename: tendonvi + "_" + tenchucnang + "_" + thoigian,
      sheets: tenchucnang,
      columns: columns,
      data: ""
    };
    var filename = tendonvi + "_" + tenchucnang + "_" + thoigian;

    return this.api.downloadFile("api/ExportExcel", param, filename);

  }

  saveExcel(danhmucid, tungay, denngay, loaiHienThi, tendonvi, tenchucnang, noidungbaocao, thoigian, mataikhoan) {
    let columns = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "makhachhang", "label": "Mã Khách Hàng", "horizontalalignment": "left" },
      { "name": "socongto", "label": "Số Công Tơ", "horizontalalignment": "center" },
      { "name": "hsn", "label": "HSN", "horizontalalignment": "right" },
      { "name": "tongsanluonggiao", "label": "Tổng SL giao (kwh)", "horizontalalignment": "right" },
      { "name": "tongsanluonggiao1", "label": "Tổng SL giao biểu 1 (kwh)", "horizontalalignment": "right" },
      { "name": "tongsanluonggiao2", "label": "Tổng SL giao biểu 2 (kwh)", "horizontalalignment": "right" },
      { "name": "tongsanluonggiao3", "label": "Tổng SL giao biểu 3 (kwh)", "horizontalalignment": "right" },
      { "name": "tongsanluongnhan", "label": "Tổng SL nhận (kwh)", "horizontalalignment": "right" },
      { "name": "tongsanluongnhan1", "label": "Tổng SL nhận biểu 1 (kwh)", "horizontalalignment": "right" },
      { "name": "tongsanluongnhan2", "label": "Tổng SL nhận biểu 2 (kwh)", "horizontalalignment": "right" },
      { "name": "tongsanluongnhan3", "label": "Tổng SL nhận biểu 3 (kwh)", "horizontalalignment": "right" },
    ];
    let para: any = JSON.stringify({
      v_Danhmucid: danhmucid,
      v_Tungay: tungay,
      v_Denngay: denngay,
      v_LoaiHienThi: loaiHienThi,
      v_pagenum: 0,
      v_numrecs: 1000000,
      v_mataikhoan: mataikhoan
    });
    let config = JSON.stringify({ namesql: "PKG_BC_SANLUONG.THONGKESANLUONG", connstr: "Amiss42" });
    let dateNow = new Date();
    let strDate = dateNow.getDate() + "-" + (dateNow.getMonth() + 1) + "-" + dateNow.getFullYear();
    let fileName = tendonvi + "_" + tenchucnang + "_" + strDate + ".xlsx";
    var param = {
      config: config,
      para: para,
      title: noidungbaocao + "_" + tendonvi + "_" + strDate,
      header: "",
      filename: fileName,
      sheets: tenchucnang,
      columns: columns,
      data: "",
      mataikhoan: mataikhoan,
      danhmucid: danhmucid,
      loaibaocao: 2,
      tenbaocao: "Báo cáo sản lượng",
    };
    return this.api.Excute("api/saveexcel", param);
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/bao-cao/thong-ke-san-luong/thongkesanluong.service.ts